import MainContainer from "../components/containers/MainContainer";
import Grid from "@material-ui/core/Grid";
import TopBar from "../components/containers/TopBar";
import t from "../Locale";
import { Button, InputLabel, TextField } from "@material-ui/core";
import PhoneInput from "react-phone-number-input";
import { useEffect, useState } from "react";
import { parseInt2 } from "../utils/functions";
import { setLoadingPage } from "../redux/items/PageLoading";
import FetchLogin from "../components/Fetch/FetchLogin";
import { useDispatch, useSelector } from "react-redux";

const Set = () => {
  const [v, setV] = useState({
    formSet: 1,
    name: "",
    contactNo: "",
    email: "",
    pin: "",
    otp: "",
    error: "",
    msg: "",
  });

  const token = useSelector((state) => state.login.token);
  const user = useSelector((state) => state.login.user);
  const dispatch = useDispatch();

  const reqOtpSet = FetchLogin("otp-set", {
    data: {
      token: token,
      name: v.name,
      contactNo: v.contactNo,
      email: v.email,
      pin: v.pin,
    },
    callbackInit: () => {
      setV2({ error: "" });
      dispatch(setLoadingPage(true));
    },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({ error: "", formSet: 2 });
      } else {
        setV2({ error: cb.response.message });
      }
      dispatch(setLoadingPage(false));
    },
  });

  const reqSet = FetchLogin("save-set", {
    data: {
      token: token,
      name: v.name,
      contactNo: v.contactNo,
      email: v.email,
      pin: v.pin,
      otp: v.otp,
    },
    callbackInit: () => {
      setV2({ error: "" });
      dispatch(setLoadingPage(true));
    },
    callback: (cb) => {
      if (cb.response.success) {
        setV2({ error: "", formSet: 3, msg: cb.response.message });
      } else {
        setV2({ error: cb.response.message });
      }
      dispatch(setLoadingPage(false));
    },
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  useEffect(() => {
    setV2({
      name: user.name,
      email: user.email,
      contactNo: user.contact_no,
    });
    // eslint-disable-next-line
  }, []);

  return (
    <MainContainer
      render={
        <Grid container>
          <Grid item xs={12} className="topMenu">
            <TopBar leftSide="-1" title={t("Settings")} />
          </Grid>
        </Grid>
      }
    >
      <div style={{ padding: 30 }}>
        {v.formSet === 1 ? (
          <>
            <div style={{ padding: "10px 0" }}>
              <InputLabel style={{ fontSize: 24 }}>Name</InputLabel>
              <TextField
                variant={"outlined"}
                value={v.name}
                onChange={(e) => setV2({ name: e.target.value })}
              />
            </div>
            <div style={{ padding: "10px 0 0" }}>
              <InputLabel style={{ fontSize: 24 }}>Mobile Number</InputLabel>
              <PhoneInput
                defaultCountry="SG"
                placeholder="98765432"
                value={v.contactNo}
                onChange={(e) => {
                  setV2({ contactNo: e });
                }}
                style={{ marginTop: 10, marginBottom: 30 }}
              />
            </div>

            <div style={{ padding: "0 0 10px" }}>
              <InputLabel style={{ fontSize: 24 }}>Email</InputLabel>
              <TextField
                variant={"outlined"}
                value={v.email}
                onChange={(e) => setV2({ email: e.target.value })}
              />
            </div>

            <div style={{ padding: "10px 0" }}>
              <InputLabel style={{ fontSize: 24 }}>Pin</InputLabel>
              <TextField
                type="number"
                length={4}
                variant={"outlined"}
                value={v.pin}
                onChange={(e) => setV2({ pin: parseInt2(e.target.value) })}
              />
            </div>

            <div style={{ textAlign: "center" }}>
              <p
                dangerouslySetInnerHTML={{ __html: v.error }}
                style={{ color: "red" }}
              />

              <Button onClick={() => reqOtpSet.handleTrigger()}>Submit</Button>
            </div>
          </>
        ) : null}
        {v.formSet === 2 ? (
          <>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <th>Name: </th>
                  <td>{v.name}</td>
                </tr>
                <tr>
                  <th>Mobile Number: </th>
                  <td>{v.contactNo}</td>
                </tr>
                <tr>
                  <th>Email: </th>
                  <td>{v.email}</td>
                </tr>
                <tr>
                  <th>Pin: </th>
                  <td>{v.pin}</td>
                </tr>
              </tbody>
            </table>
            <div style={{ padding: "30px 0" }}>
              <InputLabel style={{ fontSize: 24 }}>OTP</InputLabel>
              <TextField
                type="number"
                length={4}
                variant={"outlined"}
                value={v.otp}
                onChange={(e) => setV2({ otp: e.target.value })}
              />
            </div>
            <div style={{ textAlign: "center" }}>
              <p
                dangerouslySetInnerHTML={{ __html: v.error }}
                style={{ color: "red" }}
              />
              <Button onClick={() => setV2({ formSet: 1 })} color="default">
                Back
              </Button>{" "}
              <Button onClick={() => reqSet.handleTrigger()}>Save</Button>
            </div>
          </>
        ) : null}
        {v.formSet === 3 ? (
          <div style={{ padding: "30px 0", textAlign: "center" }}>
            <h1>{v.msg}</h1>
          </div>
        ) : null}
      </div>
    </MainContainer>
  );
};
export default Set;
